import { render, staticRenderFns } from "./GlobalParameters.vue?vue&type=template&id=99b5ca18&scoped=true&"
import script from "./GlobalParameters.vue?vue&type=script&lang=js&"
export * from "./GlobalParameters.vue?vue&type=script&lang=js&"
import style0 from "./GlobalParameters.vue?vue&type=style&index=0&id=99b5ca18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b5ca18",
  null
  
)

export default component.exports